import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from '../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const contactsHistoryStartRequest = () => {
  return {
    type: 'CONTACTS_HISTORY_START_REQUEST'
  };
};

export const contactsHistoryEndRequest = () => {
  return {
    type: 'CONTACTS_HISTORY_END_REQUEST'
  };
};

export const getAllContactsHistorySuccess = ({ data }) => {
  return {
    type: 'CONTACTS_HISTORY_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllContactsHistoryError = error => {
  return {
    type: 'CONTACTS_HISTORY_GET_ALL_ERROR',
    payload: error
  };
};

export const addContactsHistorySuccess = ({ data }) => {
  return {
    type: 'CONTACTS_HISTORY_ADD_SUCCESS',
    payload: data
  };
};

export const addContactsHistoryError = error => {
  return {
    type: 'CONTACTS_HISTORY_ADD_ERROR',
    payload: error
  };
};

export const editContactsHistorySuccess = ({ data }) => {
  return {
    type: 'CONTACTS_HISTORY_EDIT_SUCCESS',
    payload: data
  };
};

export const editContactsHistoryError = error => {
  return {
    type: 'CONTACTS_HISTORY_EDIT_ERROR',
    payload: error
  };
};

export const removeContactsHistorySuccess = id => {
  return {
    type: 'CONTACTS_HISTORY_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeContactsHistoryError = error => {
  return {
    type: 'CONTACTS_HISTORY_REMOVE_ERROR',
    payload: error
  };
};

export const contactsHistoryModifyStore = ({ data }) => {
  return {
    type: 'CONTACTS_HISTORY_MODIFY_STORE',
    payload: data
  };
};

export const addContactsHistory = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(contactsHistoryStartRequest());
      const response = await api().post('/api/contacts_history', data);
      dispatch(addContactsHistorySuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'contactsHistory',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addContactsHistoryError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(contactsHistoryEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllContactsHistory = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(contactsHistoryStartRequest());
      const response = await api().get('/api/contacts_history', { params });
      dispatch(getAllContactsHistorySuccess(response));
    } catch (err) {
      dispatch(getAllContactsHistoryError(err));
    } finally {
      dispatch(contactsHistoryEndRequest());
    }
  };
};

export const editContactsHistory = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(contactsHistoryEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(contactsHistoryStartRequest());
      const id = data._id;
      const response = await api().put('/api/contacts_history/' + id, data);
      dispatch(editContactsHistorySuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'contactsHistory',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/contacts_history'));
      }
    } catch (err) {
      dispatch(editContactsHistoryError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeContactsHistory = id => {
  return async dispatch => {
    try {
      dispatch(contactsHistoryStartRequest());
      await api().delete('/api/contacts_history/' + id);
      dispatch(removeContactsHistorySuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'contactsHistory',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Histórico de contato removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeContactsHistoryError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover histórico de contato.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(contactsHistoryEndRequest());
    }
  };
};

export const restoreContactsHistory = data => {
  return async dispatch => {
    try {
      dispatch(contactsHistoryStartRequest());
      const id = data._id;
      const response = await api().put('/api/contacts_history/' + id, data);
      dispatch(editContactsHistorySuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'contactsHistory',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Histórico de contato restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editContactsHistoryError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar histórico de contato.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(contactsHistoryEndRequest());
    }
  };
};
